import { Link } from 'react-router-dom'
import EmptyState from '../components/EmptyState.jsx'

export default function NotFoundPage() {
  return (
    <div className="container">
      <EmptyState title="404 – Seite nicht gefunden" message="Diese Seite existiert nicht oder wurde verschoben.">
        <Link to="/" className="btn btn-primary">Zur Startseite</Link>
      </EmptyState>
    </div>
  )
}
